module.exports = __webpack_public_path__ + "static/media/old-castle-placuta.1ea869a5.png";